<div [classList]="containerClassToAplly() + '-global-message'">

  <app-notification></app-notification>

  <app-global-message class="sticky-top animated fadeInDown"></app-global-message>

  @if (showAppHeader()) {
  <app-header class="sticky-top header"></app-header>
  }

  @if (showAppCartPreview()) {
  <app-cart-preview class="cart-preview cart-preview-height-global-message" [class.offcanvas-opened]="isSidebarOpen()">
  </app-cart-preview>
  }

  <main class="main-container" appScrollToTop name="scroll-to-top-ref"
    [class.header-showing-global-message]="showAppHeader()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </main>

  @if (showJustAddedProduct()) {
  <app-product-added-notification class="cart-preview just-added-product-notification">
  </app-product-added-notification>
  }

  @if (showMobileFooter()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>